module.exports = __webpack_public_path__ + "static/img/b6fdc0ef.svg";